export const MAINTENANCE_MODE = false;
                                                          
export const MAINTENANCE_TITLE = 'The Scenetale';
export const MAINTENANCE_MESSAGE =
  'We are setting the stage for a smoother cinematic experience.';
export const MAINTENANCE_SUBMESSAGE =
  'Search, watchlists, trailers, and stories will return soon.';
